import moment from 'moment-timezone';

import { formatDateTime } from 'utils/datetime';

const formatDateTimeOrNA = (timestamp, timezone) =>
	formatDateTime(timestamp, { timezone }) || 'N/A';

const formatDuration = (seconds, fromTimestamp, toTimestamp) => {
	if (typeof seconds === 'number') {
		const duration = moment.duration(seconds, 'seconds');
		return `${Math.floor(duration.asHours())}h ${duration.minutes()}min`;
	}

	if (!fromTimestamp || !toTimestamp) return 'N/A';

	const duration = moment.duration(moment(toTimestamp).diff(moment(fromTimestamp)));
	return `${Math.floor(duration.asHours())}h ${duration.minutes()}min`;
};

const formatMileage = (distanceKm) => {
	if (distanceKm == null) return 'N/A';
	return `${Math.round(distanceKm * 0.621371)}mi`;
};

const buildCardKey = (item, index, firstSequence, lastSequence) =>
	[
		item?.run?.name ?? 'no-run',
		item?.job?.code ?? 'no-job',
		firstSequence?.fromTimestamp ?? 'no-from',
		lastSequence?.toTimestamp ?? 'no-to',
		index,
	].join('__');

export const mapAssignmentToCard = (item, index) => {
	const sequences = item?.workAssignmentSequences ?? [];
	const firstSequence = sequences[0] ?? null;
	const lastSequence = sequences[sequences.length - 1] ?? null;
	const fromName = firstSequence?.fromStation?.name ?? 'N/A';
	const toName = lastSequence?.toStation?.name ?? 'N/A';

	return {
		key: buildCardKey(item, index, firstSequence, lastSequence),
		sequenceGroupId: item?.sequenceGroupId ?? null,
		fromStationId: firstSequence?.fromStation?.id ?? null,
		toStationId: lastSequence?.toStation?.id ?? null,
		fromStationName: firstSequence?.fromStation?.code ?? firstSequence?.fromStation?.name ?? 'N/A',
		toStationName: lastSequence?.toStation?.code ?? lastSequence?.toStation?.name ?? 'N/A',
		activityType: 'driving',
		runName: item?.run?.name ?? 'N/A',
		jobCode: item?.job?.code ?? 'N/A',
		route: `${fromName} → ${toName}`,
		plannedDeparture: formatDateTimeOrNA(
			firstSequence?.fromTimestamp,
			firstSequence?.fromStation?.timezone
		),
		plannedArrival: formatDateTimeOrNA(
			lastSequence?.toTimestamp,
			lastSequence?.toStation?.timezone
		),
		mileage: formatMileage(item?.job?.distanceKm),
		duration: formatDuration(
			item?.job?.durationSeconds,
			firstSequence?.fromTimestamp,
			lastSequence?.toTimestamp
		),
		assigneeId: item?.isProblematic ? null : (item?.crewMember?.id ?? null),
		assigneeName: item?.isProblematic ? null : (item?.crewMember?.fullName ?? null),
		assigneeCurrentRun: item?.isProblematic ? undefined : item?.crewMember?.currentRun,
	};
};
